import { render, staticRenderFns } from "./smallbox.vue?vue&type=template&id=f72b1a54&scoped=true"
import script from "./smallbox.vue?vue&type=script&lang=js"
export * from "./smallbox.vue?vue&type=script&lang=js"
import style0 from "./smallbox.vue?vue&type=style&index=0&id=f72b1a54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72b1a54",
  null
  
)

export default component.exports